import { RAISE_API_V1_URL } from "constants/endpoints";
import { post } from "services/api";
import { prepareRiskRequest } from "services/sardine";

export const signUp = async ({
  XSession,
  fingerprint,
  email,
  phone,
  password,
  confirmPassword: password_confirmation,
  referralCode,
  captchaToken
}) => {
  const risk = await prepareRiskRequest("signup");
  const URL = `${RAISE_API_V1_URL}/users`;
  const sessionId = risk.sessionId || XSession;

  const headers = {
    "device-fingerprint": fingerprint,
    "X-Risk-Collection": risk.collection
  };
  if (sessionId) headers["X-Session"] = sessionId;

  const body = {
    user_registration_form: {
      email,
      phone,
      password,
      password_confirmation,
      referral_code: referralCode,
      accept_terms: true
    },
    recaptcha_token: captchaToken
  };

  const response = await post(URL, body, { headers });
  return response.data;
};
